import type { TConstraints } from '@feathr/rachis';

import { EIntegrationTypes } from '../integrations';
import { TargetableClass } from './targetable.types';
import { type ITargetableBase, TargetableBase } from './targetable_base';

export interface IGoogleAdsLocationInfo {
  geo_target_constant: string;
}

/**
 * Interface for Google Ads geo targetables
 */
export interface IGoogleGeoTargetable extends ITargetableBase {
  _cls: TargetableClass.google_ads_geo;
  location_info: IGoogleAdsLocationInfo;
}

/**
 * GoogleGeoTargetable class for Google Ads geo targetables
 */
export class GoogleGeoTargetable extends TargetableBase<IGoogleGeoTargetable> {
  public override className = 'Targetable.GoogleGeoTargetable';

  public override getDefaults(): Partial<IGoogleGeoTargetable> {
    return {
      ...super.getDefaults(),

      _cls: TargetableClass.google_ads_geo,
      integrations: [EIntegrationTypes.GoogleAds],
    };
  }

  public override get constraints(): TConstraints<IGoogleGeoTargetable> {
    return {
      ...super.constraints,
      _cls: {
        inclusion: [TargetableClass.google_ads_geo],
      },
    };
  }
}
